import React, {useState, useEffect} from 'react'
import { db } from "../FirebaseConfig/firebaseConfig";
import { collection, addDoc, query, onSnapshot } from "firebase/firestore"
import {YourWishWrapper, FormLeft, WishesRight, FormHeader,Form, MiddleDivider} from "./YourWishStyle"
import 'antd/dist/antd.min.css'
import { Input, Button } from 'antd';
import WishCard from "../WishCard/WishCard"




const { TextArea } = Input;
function YourWish() {
    
    const [name, setName] = useState("");
    const [wish, setWish] = useState("");
    const [allWish, setAllWish] = useState([]);


    const addWish = async () =>{
        await addDoc(collection(db, 'wishes'), {
            name,
            wish,
            createdAt: new Date(),
        });
        setName("");
        setWish("");
    };

    const getAllWish = () =>{
        try {
            const q = query(collection(db, 'wishes'));
            const unsub = onSnapshot(q, (querySnapshot)=>{
            let wishArray = [];
            querySnapshot.forEach((doc)=>{
                wishArray.push({...doc.data(), id: doc.id});
            });
            setAllWish(wishArray);
        });
        return ()=> unsub();
        }catch(e){
            console.log({message: e.message})
        } 
    }

    useEffect(()=>{
        getAllWish();
    }, []);

    return (
        <YourWishWrapper>
            <FormLeft>
                <FormHeader>your birthday wish</FormHeader>
                <Form>
                    <Input
                      type="text"
                        value={name}
                        placeholder="Enter Your Name"
                        style={{ 
                            fontSize: '12px',
                            textTransform: "capitalize",
                            marginBottom: "10px"
                           }}
                        onChange={(e)=>{
                            setName(e.target.value);
                        }}
                      />
                    <TextArea
                      type="text-area"
                      value={wish}
                      placeholder="Write your wish"
                      style={{ 
                          fontSize: '12px',
                          textTransform: "capitalize",
                          marginBottom: "10px",
                          resize: "none"
                         }}
                      onChange={(e)=>{
                          setWish(e.target.value);
                      }}
                      />
                    <Button 
                    type="primary" block
                    style={{ 
                        fontSize: '12px',
                        textTransform: "uppercase",
                        fontWeight: "700"
                       }}
                    onClick={()=>{
                        if(name === "" || wish === ""){
                            alert("Field Can't Be Empty!!!")
                        }else{
                            addWish();
                        // console.log("worked")
                        }
                        
                    }}
                    >send</Button>
                </Form>
            </FormLeft>
            <MiddleDivider>middle</MiddleDivider>
            <WishesRight>
                { allWish.map(({id, name, wish, createdAt})=>(
                    <WishCard key={id} name={name} wish={wish} createdAt={createdAt} />
                )) }
            </WishesRight>
        </YourWishWrapper>
    )
}

export default YourWish
